import {FC} from "react";
import {useOutletContext} from "react-router-dom";
import {UserPageOutletContext} from "../index";
import { UserVisitControlTabContent } from "./content";

export const UserVisitControlTab: FC<any> = () => {
    const [user] = useOutletContext<UserPageOutletContext>();
    return <UserVisitControlTabContent user={user}/>;
};
